import clsx from 'clsx';
import { default as MUIInputLabel, InputLabelProps as MUIInputLabelProps } from '@material-ui/core/InputLabel';

import './InputLabel.css';

//
// --- Types ---

export interface InputLabelProps extends MUIInputLabelProps {
  className?: string;
  'data-testid'?: string;
}

//
// --- InputLabel Component ---

const InputLabel: React.FC<InputLabelProps> = ({
  className,
  'data-testid': dataTestId = 'input-label',
  ...remainingInputLabelProps
}) => (
  <MUIInputLabel className={clsx('input-label', className)} data-testid={dataTestId} {...remainingInputLabelProps} />
);

export default InputLabel;
